<div class="mt-0" [ngClass]="noMargin ? 'mb-0' : 'mb-7'" data-cy="app-widget">
  <h2 class="mt-0 mb-5" data-cy="app-widget-title">{{ title }}</h2>
  <div *ngIf="noCard">
    <ng-container *ngTemplateOutlet="tempOutlet"></ng-container>
  </div>
  <p-card *ngIf="!noCard">
    <ng-container *ngTemplateOutlet="tempOutlet"></ng-container>
  </p-card>
</div>

<ng-template #tempOutlet>
  <ng-content></ng-content>
</ng-template>
